import type { PillProps } from './Pill.types';

const baseClasses =
  'tw:inline-flex tw:h-8 tw:items-center tw:rounded-full tw:border tw:border-solid tw:px-3 tw:text-sm tw:whitespace-nowrap';

const selectionClasses =
  'tw:border-sq-tool-btn-border tw:bg-sq-colored-hover tw:text-black tw:dark:bg-sq-colored-hover-dark tw:dark:text-white';

export const Pill = ({ children, testId, extraClassNames = '' }: PillProps) => (
  <span data-testid={testId} className={`${baseClasses} ${selectionClasses} ${extraClassNames}`.trim()}>
    {children}
  </span>
);

export default Pill;
